export const ETableDB = {
    APIS: 'apis'
}

export const EActionDB = {
    UPDATE: 'UPDATE',
    UPDATE_API_DATA: 'UPDATE_API_DATA'
}
